import * as React from "react";
const SvgPlus20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        fill: "black",
        viewBox: "0 0 12 12"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M7 0v5h5v2H7v5H5V7H0V5h5V0h2Z",
      clipRule: "evenodd"
    })
  );
export default SvgPlus20Px;
